import { render, staticRenderFns } from "./coach_invitation.vue?vue&type=template&id=2102c796&"
import script from "./coach_invitation.vue?vue&type=script&lang=js&"
export * from "./coach_invitation.vue?vue&type=script&lang=js&"
import style0 from "./coach_invitation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports